'use client';

import type { ChoiceType } from '~/model/ChoiceType';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

export const SelectResult = ({
  resultId,
  resultData,
  answerChoices,
}: SelectResultPropsType) => {
  const t = useTranslations('SURVEY.RESULTS');
  const [shrinkedList, setShrinkedList] = useState(true);
  const numberOfVisibleItems = 4;

  const firstChoice
    = resultData
      && resultData.length > 0
      && answerChoices.length > 0
      && answerChoices.find(q => q['@id'] === resultData[0]['@id']).title;

  return (
    <div data-testid="select">
      {resultData && resultData.length > 0 && (
        <div className="result__banner">
          {t.rich('FIRST_CHOICE', {
            firstChoice,
          })}
        </div>
      )}
      {resultData
        && resultData
          .slice(0, shrinkedList ? numberOfVisibleItems : undefined)
          .map((item: Data, index: number) => {
            const { percentage } = item;
            const choice
              = resultData
                && resultData.length > 0
                && answerChoices?.length > 0
                && answerChoices.find(q => q['@id'] === item['@id']).title;
            const bar = (
              <>
                <div
                  className="choice-question__percentage--top"
                  data-testid="choice-question-label"
                >
                  <p>{choice}</p>
                  <span>
                    {Math.round(percentage)}
                    %
                  </span>
                </div>
                <div className="choice-question__percentage--track">
                  <div
                    className="choice-question__percentage--track--bar"
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </>
            );
            return (
              <div className="result__line" key={`Select-${index}-${resultId}`}>
                <div className="choice-question__percentage">{bar}</div>
              </div>
            );
          })}
      {resultData.length > numberOfVisibleItems && (
        <div
          className="result__banner result__banner__footer"
          onClick={() => setShrinkedList(!shrinkedList)}
          onKeyDown={e => e.key === 'Enter' && setShrinkedList(!shrinkedList)}
          role="button"
          tabIndex={0}
        >
          {shrinkedList
            ? (
                <>
                  {t('MORE_COMMENT', {
                    comment: resultData.length - numberOfVisibleItems,
                  })}
                </>
              )
            : (
                <>{t('LESS_COMMENT')}</>
              )}
        </div>
      )}
    </div>
  );
};

export interface SelectResultPropsType {
  resultId: number;
  resultData: Data[];
  answerChoices: ChoiceType[];
}

interface Data {
  choice: string;
  percentage: number;
  '@id': string;
}
